import axios from 'axios';
import { auth } from '../components/firebaseConfig';
import config from '../config';

const api = axios.create({
    baseURL: config.baseUrl,
});

api.interceptors.request.use(async (reqConfig) => {
    const user = auth.currentUser;
    if (user) {
        const token = await user.getIdToken();
        reqConfig.headers.Authorization = `Bearer ${token}`;
    }
    return reqConfig;
}, (error) => Promise.reject(error));

export default api;
